import { Button, Typography } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import { StyledHeaderH1 } from "reusable/wrappers/CenterText"
import styled from "styled-components"
import { StyledBody, StyledHeaderH2 } from "../../../reusable/wrappers/BodyText"

const StyledWrapper = styled.div`
  text-align: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
  }
`
const StyledBodyRed = styled(Typography).attrs({ variant: "body2" })`
  color: ${(p) => p.theme.colors.mazdaRed};
  text-align: right;
  margin-top: 20px;
`

const StyledLine = styled.div`
  border: 0.5px solid ${(p) => p.theme.colors.darkGrey};
  margin-top: 40px;
`

const StyledButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`

const StyledButton = styled(Button).attrs({ variant: "outlined" })`
  min-width: 60px;
  height: 40px;
  border: 2px solid black;
  &:hover {
    border: 2px solid black;
  }
`

const WarrantyHeader = () => {
  const isDesktop = useIsDesktop()
  return (
    <StyledWrapper>
      <StyledHeaderH1>כתב אחריות</StyledHeaderH1>
      <StyledBody $margin={20} $fontSize="20">
        שמחים שהתחדשת במאזדה!
      </StyledBody>
      <StyledBody $margin={20}>
        כאן אפשר להתעדכן בתנאים העיקריים של האחריות לרכב חדש.
        <br />
        פרטי האחריות המלאים יימסרו לך עם קבלת הרכב
      </StyledBody>
      {!isDesktop && (
        <StyledButtonWrapper>
          <StyledButton onClick={() => window.print()}>הדפס</StyledButton>
        </StyledButtonWrapper>
      )}
      <StyledHeaderH2
        $position="right"
        $margin={20}
        $fontSize="20"
        $fontWeight="300"
      >
        סוגי האחריות המוענקים לרכב מאזדה חדש:
      </StyledHeaderH2>
      <StyledBody $position="right" $margin={20}>
        1.אחריות מוגבלת לרכב חדש
      </StyledBody>
      <StyledBody $position="right" $margin={20}>
        2.אחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים
      </StyledBody>
      <StyledBody $position="right" $margin={20}>
        3.אחריות מוגבלת לפגיעות חלודה חודרת
      </StyledBody>
      <StyledBody $position="right" $margin={20}>
        4. אחריות מוגבלת לחלפים מקוריים
      </StyledBody>
      <StyledBodyRed>
        *חשוב - מסמך זה נועד לידיעה בלבד. <br></br>
        הנוסח הקובע של האחריות מפורט בחוברת האחריות ורישום הטיפולים.
      </StyledBodyRed>
      {isDesktop && (
        <StyledButtonWrapper>
          <StyledButton onClick={() => window.print()}>הדפסה</StyledButton>
        </StyledButtonWrapper>
      )}
      {isDesktop && <StyledLine />}
    </StyledWrapper>
  )
}

export default WarrantyHeader
